// ISO 639-1 (and a couple of common non-standard) codes for languages that
// are written right-to-left. Keep this in sync with the PHP copy at
// common/Localizations/RtlLanguages.php used for the initial server render.
const RTL_LANGUAGE_CODES = new Set([
  'ar', // Arabic
  'arc', // Aramaic
  'dv', // Divehi
  'fa', // Persian / Farsi
  'ha', // Hausa (when written in Arabic script)
  'he', // Hebrew
  'iw', // Hebrew (old code)
  'khw', // Khowar
  'ks', // Kashmiri
  'ku', // Kurdish
  'ps', // Pashto
  'sd', // Sindhi
  'ug', // Uyghur
  'ur', // Urdu
  'yi', // Yiddish
]);

/**
 * Whether the given language/locale code should be displayed right-to-left.
 * Accepts plain codes ("fa") or locale strings with a region/script
 * subtag ("fa-IR", "fa_IR", "ar-EG").
 */
export function isRtlLocale(code?: string | null): boolean {
  if (!code) return false;
  const primarySubtag = code.split(/[-_]/)[0].toLowerCase();
  return RTL_LANGUAGE_CODES.has(primarySubtag);
}
